
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import OnzeAanpakPage from '../pages/onze-aanpak/page';
import TrainingenPage from '../pages/trainingen/page';
import SamenwerkingenPage from '../pages/samenwerkingen/page';
import DoeMeePage from '../pages/doe-mee/page';
import ContactPage from '../pages/contact/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/over-herstart',
    element: <AboutPage />
  },
  {
    path: '/onze-aanpak',
    element: <OnzeAanpakPage />
  },
  {
    path: '/trainingen',
    element: <TrainingenPage />
  },
  {
    path: '/samenwerkingen',
    element: <SamenwerkingenPage />
  },
  {
    path: '/doe-mee',
    element: <DoeMeePage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
